import { tracking } from '@iwoca/frontend-tracking-library';
import { IconGearOutline } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { Drawer } from 'components/Drawer/Drawer';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { ColumnToggles } from './ColumnToggles/ColumnToggles';
import styles from './DashboardSettings.module.css';
import { DateRangeFilter } from './DateRangeFilter/DateRangeFilter';
import { ManagedByIwocaToggle } from './ManagedByIwocaToggle/ManagedByIwocaToggle';

export const DashboardSettings = () => {
  const { isSettingsOpen, setIsSettingsOpen } = useDashboard();
  const { checkIntroducerPermission } = useIntroducerData();

  const handleToggle = () => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Dashboard settings',
    });
    setIsSettingsOpen((prev) => !prev);
  };

  return (
    <>
      <Button
        id="dashboard-settings"
        data-testid="dashboard-settings-toggle-button"
        onClick={handleToggle}
        variant="tertiary"
        className={styles.toggleButton}
      >
        <IconGearOutline className={styles.icon} />
        <Trans>Dashboard settings</Trans>
      </Button>
      <Drawer show={isSettingsOpen} onClose={handleToggle}>
        <DateRangeFilter />
        <hr className={styles.divider} />
        {checkIntroducerPermission('can_see_partner_applications') && (
          <>
            <ManagedByIwocaToggle />
            <hr className={styles.divider} />
          </>
        )}
        <ColumnToggles />
      </Drawer>
    </>
  );
};
